import { useSelector, useDispatch } from "react-redux";
import styled from "styled-components";
import Tile from "./Tile";
import {
  StockContainer,
  Title,
  SubTitle,
  Button,
  Modal,
  ModalContent,
  BlockInfo,
  BlockContent,
  ButtonBlock,
} from "./styled";
import { restartGame } from "../redux/dominoSlice";
import { localizations, getLanguage } from "./localization";

const Message = styled(SubTitle)`
  font-weight: 500;
  font-size: 0.9rem;
  color: #9ec4f1;
`;
const WinMessage = styled(Message)`
  font-size: 1.3rem;
`;
const LoseMessage = styled(WinMessage)`
  color: red;
`;

const User = () => {
  const {
    players: [user],
    stock,
    winner,
  } = useSelector((state) => state.domino);
  const dispatch = useDispatch();
  const handleRestart = () => {
    window.ysdk.features.GameplayAPI.stop();
    window.ysdk.adv.showFullscreenAdv({
      callbacks: {
        onClose: function (wasShown) {
          window.ysdk.features.GameplayAPI.start();
          dispatch(restartGame());
        },
        onError: function (error) {},
      },
    });
  };
  return (
    <>
      <Title>{`${localizations.player[getLanguage()]}: ${user?.name}`}</Title>
      {winner?.id !== 1 && !user?.stock?.length && (
        <SubTitle>{localizations.waiting[getLanguage()]}</SubTitle>
      )}
      <StockContainer>
        {user?.stock?.map((tile) => (
          <Tile key={tile.id} tile={tile} draggable={!winner} />
        ))}
      </StockContainer>
      {winner &&
        (winner?.id === 1 ? (
          <Modal>
            <ModalContent>
              <BlockInfo>{localizations.winTitle[getLanguage()]}</BlockInfo>
              <BlockContent>
                {localizations.winDescription[getLanguage()]}
              </BlockContent>
              <ButtonBlock>
                <Button onClick={handleRestart}>
                  {localizations.startOver[getLanguage()]}
                </Button>
              </ButtonBlock>
            </ModalContent>
          </Modal>
        ) : (
          <Modal>
            <ModalContent>
              <BlockInfo>{localizations.loseTitle[getLanguage()]}</BlockInfo>
              <BlockContent>
                {localizations.winDescription[getLanguage()]}
              </BlockContent>
              <ButtonBlock>
                <Button onClick={handleRestart}>
                  {localizations.startOver[getLanguage()]}
                </Button>
              </ButtonBlock>
            </ModalContent>
          </Modal>
        ))}
    </>
  );
};

export default User;
